import { Koi } from '@ksyos/koi';
import { emailSchema } from './schemas/emailSchema';
import { phoneNumberSchema } from './schemas/phoneNumberSchema';

export interface ICareProviderContactDraft {
    emailAddress: string | null;
    phoneNumber: string | null;
}

export const careProviderContactFinal = Koi.object().keys({
    emailAddress: emailSchema,
    phoneNumber: phoneNumberSchema,
});

export const careProviderContactDraft = Koi.object({
    emailAddress: emailSchema.allow(null),
    phoneNumber: phoneNumberSchema.allow(null),
});
